<template>
  <b-tabs content-class="mt-3">
    <images-tab
        ref="tabImages"
        @refresh-data="refreshTabData"
        :entity-id="entityId"
        entity-type="gallery"
    />
    <log-tab
      ref="tabLogTable"
      :entity-id="entityId"
      entity-type="gallery"
    />
  </b-tabs>
</template>

<script>
import {
  BTabs,
} from 'bootstrap-vue'
import imagesTab from '@/views/pages/_components/_tab/_shared/_update/images.vue'
import logTab from '@/views/pages/_components/_tab/_log/_list.vue'

export default {
  components: {
    BTabs,
    imagesTab,
    logTab,
  },
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  methods: {
    refreshTabData() {
      this.$emit('refresh-tabs-data')
    },
    refreshLog() {
      this.$refs.tabLogTable.initData()
    },
    refreshImages() {
      this.$refs.tabImages.initTab()
    },
  }
}
</script>

<style scoped>

</style>
